// extracted by mini-css-extract-plugin
export var label = "_dr-1";
export var reminder = "_dr-0";